"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faExclamationTriangle = require("@fortawesome/pro-regular-svg-icons/faExclamationTriangle");

var _peractoUi = require("@peracto/peracto-ui");

var _renderer = require("@react-page/renderer");

var _Draggable = _interopRequireDefault(require("../../ContentBlockList/Draggable"));

var S = _interopRequireWildcard(require("../styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var uniquifyCell = function uniquifyCell(cell) {
  var _cell$rows;

  delete cell.id;

  if (!(cell !== null && cell !== void 0 && cell.rows) || cell.rows.length === 0) {
    return cell;
  }

  var cellClone = _objectSpread(_objectSpread({}, cell), {}, {
    rows: cell === null || cell === void 0 ? void 0 : (_cell$rows = cell.rows) === null || _cell$rows === void 0 ? void 0 : _cell$rows.map(function (row) {
      var _row$cells;

      var uniqueRow = _objectSpread({}, row);

      delete uniqueRow.id;

      if ((row === null || row === void 0 ? void 0 : (_row$cells = row.cells) === null || _row$cells === void 0 ? void 0 : _row$cells.length) > 0) {
        var _row$cells2;

        uniqueRow.cells = row === null || row === void 0 ? void 0 : (_row$cells2 = row.cells) === null || _row$cells2 === void 0 ? void 0 : _row$cells2.map(function (cell) {
          return uniquifyCell(cell);
        });
      }

      return uniqueRow;
    })
  });

  return cellClone;
};

var LibraryBlock = function LibraryBlock(_ref) {
  var _cells$, _cells$$layout, _cells$$layout$plugin;

  var block = _ref.block,
      editor = _ref.editor,
      plugins = _ref.plugins,
      handleDelete = _ref.handleDelete;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var name = block.name,
      body = block.body;
  var state = JSON.parse(body)[0];
  var cells = state.cells;
  var Draggable = (0, _Draggable["default"])(cells === null || cells === void 0 ? void 0 : (_cells$ = cells[0]) === null || _cells$ === void 0 ? void 0 : (_cells$$layout = _cells$.layout) === null || _cells$$layout === void 0 ? void 0 : (_cells$$layout$plugin = _cells$$layout.plugin) === null || _cells$$layout$plugin === void 0 ? void 0 : _cells$$layout$plugin.name);
  return /*#__PURE__*/_react["default"].createElement(S.LibraryBlock, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-editor__block",
    style: {
      margin: '15px 0'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-editor__block--icon"
  }, /*#__PURE__*/_react["default"].createElement(Draggable, {
    insert: editor.plugins.unserialize(uniquifyCell(cells[0]))
  }, /*#__PURE__*/_react["default"].createElement(_renderer.HTMLRenderer, {
    state: state,
    plugins: plugins
  }))), /*#__PURE__*/_react["default"].createElement(S.ItemName, null, /*#__PURE__*/_react["default"].createElement("span", null, name), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-light",
    onClick: function onClick() {
      return setShowModal(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash
  })))), showModal && /*#__PURE__*/_react["default"].createElement(_peractoUi.Modal, {
    isVisible: showModal,
    title: "Delete Library Block",
    close: function close() {
      return setShowModal(false);
    },
    buttons: [{
      type: 'btn-outline-secondary',
      text: 'Close',
      action: function action() {
        return setShowModal(false);
      }
    }, {
      type: 'btn-danger',
      text: 'Delete Block',
      action: handleDelete(block)
    }]
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faExclamationTriangle.faExclamationTriangle,
    size: "4x",
    className: "d-block mb-4"
  }), "Are you sure you would like to permanently delete \"", block.name, "\"?"));
};

var _default = LibraryBlock;
exports["default"] = _default;